import { CombinedSweep } from '@/components/util/sdk/sweep/types';
import { getEuclidianDistance } from '@/_models/virtualStaging/PathFinderLine/utils';
// import { addDebugLineBetweenPoints } from './helper';
import * as THREE from 'three';

export function checkIntersection(
  point1: Pick<CombinedSweep, 'positionX' | 'positionY' | 'positionZ' | 'isCustom'>,
  point2: Pick<CombinedSweep, 'positionX' | 'positionY' | 'positionZ' | 'isCustom'>,
  barrier: any,
  scene: any,
) {
  const start = new THREE.Vector3(point1.positionX, point1.positionY, point1.positionZ);
  const end = new THREE.Vector3(point2.positionX, point2.positionY, point2.positionZ);
  const direction = new THREE.Vector3().subVectors(end, start).normalize();
  const distance = getEuclidianDistance(point1, point2);

  const raycaster = new THREE.Raycaster(start, direction);
  const intersects = raycaster
    .intersectObject(barrier, true)
    .filter((i: any) => i.distance < distance);

  // Debug method, uncomment to see all sweep connections
  // Red lines represent connections blocked by barriers
  // addDebugLineBetweenPoints(
  //   point1,
  //   point2,
  //   intersects.length > 0 ? 0xff0000 : 0x0000ff,
  //   scene,
  //   THREE
  // );

  return intersects;
}
